import {
  DashboardOutlined,
  UserOutlined,
  SettingOutlined,
  FileOutlined,
  TeamOutlined,
  BarChartOutlined,
  AppstoreOutlined,
  LinkOutlined,
  FileAddOutlined,
  UnorderedListOutlined,
  InboxOutlined,
  TableOutlined,
  DatabaseOutlined,
  FileTextOutlined,
  TagOutlined,
  BarcodeOutlined,
  ShopOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CheckSquareOutlined,
  ScanOutlined,
  ProfileOutlined,
  LockOutlined,
  LogoutOutlined,
  BorderlessTableOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  FlagOutlined,
  IdcardOutlined,
  ApartmentOutlined,
  SafetyCertificateOutlined,
  FolderOutlined,
  UserAddOutlined,
  TagsOutlined,
  ShoppingCartOutlined,
  ClusterOutlined,
  ShareAltOutlined,
  KeyOutlined,
  FileDoneOutlined,
  AuditOutlined,
  ThunderboltOutlined,
  UploadOutlined,
  HistoryOutlined,
  PercentageOutlined,
  EditOutlined,
  FormOutlined,
  ApiOutlined,
  ContainerOutlined,
  FileProtectOutlined,
  CalculatorOutlined,
  PlusCircleOutlined,
  OrderedListOutlined,
  HourglassOutlined,
  WarningOutlined,
  SolutionOutlined,
  FileSearchOutlined,
  AreaChartOutlined,
  CalendarOutlined,
  LineChartOutlined,
  ContactsOutlined,
  TrophyOutlined,
} from "@ant-design/icons";

import AssignRoleSetting from "../AdminSetting/AssignRoleSettings";
import MenuSettings from "../AdminSetting/MenuSettings";
import UserSetting from "../AdminSetting/UserSetting";
import NewRegisterVendor from "../VendorMaster/NewRegisterVendorMaster";
import TriggerVendorMaster from "../VendorMaster/TriggerVendorRegisterLink";
import RegistrationVendorMaster from "../VendorMaster/VendorRegistrationApprovalRequest";
import ListForApprove from "../VendorMaster/ListForApprove";
import VendorReports from "../VendorMaster/VendorReports";
import AllPo from "../IRNRegister/ALLPO";
import ListRegister from "../IRNRegister/ListRegister";
import InwardRegister from "../IRNRegister/InwardRegister";
import BarCodeLiquidationMaster from "../LiquidationBarCodeNew/BarCodeLiquidationMaster";
import BarCodeLiquidationAgeingStore from "../LiquidationBarCodeNew/AgeingStore";
import LiquidationBarcodeListForApprove from "../LiquidationBarCodeNew/ListForApprove";
import LiquidationBarcodeFinalReport from "../LiquidationBarCodeNew/FinalReport";
import NearToExpiryApprovedList from "../NearToExpiry/ApprovedList";
import NearToExpiryAllList from "../NearToExpiry/NearToexpiryAllList";
import NearToExpiryScan from "../NearToExpiry/NearToExpiryScan";
import NearToExpiryItem from "../NearToExpiry/NearToExpiryItem";
import NearToExpiryListForApprove from "../NearToExpiry/ListForApprove";
import EmployeeMaster from "../Master/EmployeeMaster";
import DepartmentMaster from "../Master/Department";
import DesignationMaster from "../Master/Designation";
import CountryMaster from "../Master/Country";
import StateMaster from "../Master/State";
import UOM from "../Master/UOM";
import CityMaster from "../Master/City";
import RoleSettings from "../AdminSetting/RoleSettings";
import MenuGroup from "../AdminSetting/MenuGroup";
import RegsiterUser from "../AdminSetting/ResgisterUser";
import ChangePassword from "../Settings/ChangePassword";
import SAPStore from "../SAPIntegrationReports/Store";
import SAPCategory from "../SAPIntegrationReports/Category";
import SAPItemMaster from "../SAPIntegrationReports/ItemMaster";
import SAPPurchaseOrder from "../SAPIntegrationReports/PurchaseOrder";
import { UserListGrid } from "../AdminSetting/UserList";
import UserManagement from "../AdminSetting/UserListTest";
import ApprovalGroup from "../AdminSetting/ApprovalSettings";
import ApprovalUserMapping from "../AdminSetting/ApprovalUserMapping";
import NearToExpirySAP from "../SAPIntegrationReports/NearToExpiry";
import GRNList from "../SAPIntegrationReports/GRNList";
import { UpdateLegalName } from "../AdminSetting/UpdateLegalName";
import StockAging from "../SAPIntegrationReports/StockAging";
import GRNReport from "../GRNModule/GRNReport";
import BarCodeLiquidationAgeingAll from "../LiquidationBarCodeNew/AllList";
import UploadTOTDocument from "../VendorMaster/UploadTOTDocument";
import FormMaster from "../AdminSetting/FormMaster";
import VendorAuditReport from "../VendorMaster/VendorAuditReport";
import DivisionWisePOGRNSummaryReport from "../Reports/DivisionWisePOGRNSummaryReport";
import DivisionVendorFillRate from "../Reports/DivisionVendorFillRate";

export const menuConfig = {

  // ─── Dashboard ─────────────────────────────────────────────────────────────
  form_1: {
    title: "Dashboard",
    icon: <DashboardOutlined />,
    description: "Overview of key metrics and activity.",
  },

  // ─── Master ────────────────────────────────────────────────────────────────
  form_2: {
    title: "Country",
    icon: <GlobalOutlined />,
    description: "Create and maintain country-level data.",
    content: <CountryMaster />,
  },
  form_3: {
    title: "State",
    icon: <FlagOutlined />,
    description: "Manage state information linked to cities and countries.",
    content: <StateMaster />,
  },
  form_4: {
    title: "City",
    icon: <EnvironmentOutlined />,
    description: "Add, update, and maintain city records.",
    content: <CityMaster />,
  },
  form_5: {
    title: "Designation",
    icon: <SolutionOutlined />,
    description: "Configure job titles and hierarchical position data.",
    content: <DesignationMaster />,
  },
  form_6: {
    title: "Department",
    icon: <ApartmentOutlined />,
    description: "Manage departments and organizational structure details.",
    content: <DepartmentMaster />,
  },
  form_8: {
    title: "Employee Master",
    icon: <TeamOutlined />,
    description: "Create and maintain employee profiles and assignments.",
    content: <EmployeeMaster />,
  },
  form_29: {
    title: "Unit of Measurement",
    icon: <CalculatorOutlined />,
    description: "Manage and configure measurement units used across the system.",
    content: <UOM />,
  },

  // ─── Vendor Master ─────────────────────────────────────────────────────────
  new_registration: {
    title: "New Vendor Registration",
    icon: <UserAddOutlined />,
    description: "Register new vendors into the system.",
    content: <NewRegisterVendor />,
  },
  form_28: {
    title: "Trigger Vendor Registration Link",
    icon: <ThunderboltOutlined />,
    description: "Resend email invitation to vendors.",
    content: <TriggerVendorMaster />,
  },
  form_34: {
    title: "Vendor Profile",
    icon: <ContactsOutlined />,
    description: "View all vendor profiles.",
    content: <RegistrationVendorMaster />,
  },
  form_35: {
    title: "Vendor List For Approve",
    icon: <CheckCircleOutlined />,
    description: "Approve or reject pending vendor registrations.",
    content: <ListForApprove />,
  },
  form_40: {
    title: "Vendor Report",
    icon: <BarChartOutlined />,
    description: "View and analyse vendor reports.",
    content: <VendorReports />,
  },
  form_51: {
    title: "Vendor Audit Report",
    icon: <AuditOutlined />,
    description: "Audit trail and compliance report for vendors.",
    content: <VendorAuditReport />,
  },
  form_45: {
    title: "Upload TOT Document",
    icon: <UploadOutlined />,
    description: "Upload Trade-On-Terms documents for vendors.",
    content: <UploadTOTDocument />,
  },

  // ─── IRN Register ──────────────────────────────────────────────────────────
  form_15: {
    title: "IRN All PO",
    icon: <OrderedListOutlined />,
    description: "View all purchase orders in the IRN register.",
    content: <AllPo />,
  },
  form_16: {
    title: "Inward Register",
    icon: <InboxOutlined />,
    description: "Track all inward stock entries.",
    content: <InwardRegister />,
  },
  form_17: {
    title: "IRN List Register",
    icon: <TableOutlined />,
    description: "Manage IRN list register entries.",
    content: <ListRegister />,
  },

  // ─── Liquidation Barcode ───────────────────────────────────────────────────
  form_18: {
    title: "Barcode Liquidation Master",
    icon: <BarcodeOutlined />,
    description: "Manage barcode liquidation master records.",
    content: <BarCodeLiquidationMaster />,
  },
  form_19: {
    title: "Barcode Liquidation Aging Update",
    icon: <HistoryOutlined />,
    description: "Update aging status of liquidation barcodes.",
    content: <BarCodeLiquidationAgeingStore />,
  },
  form_20: {
    title: "Liquidation Barcode List For Approve",
    icon: <CheckCircleOutlined />,
    description: "Review and approve liquidation barcode lists.",
    content: <LiquidationBarcodeListForApprove />,
  },
  form_21: {
    title: "Liquidation Barcode Final Report",
    icon: <FileTextOutlined />,
    description: "View final reports for liquidation barcodes.",
    content: <LiquidationBarcodeFinalReport />,
  },
  form_44: {
    title: "Barcode Liquidation Aging All",
    icon: <ClockCircleOutlined />,
    description: "View complete aging list for all liquidation barcodes.",
    content: <BarCodeLiquidationAgeingAll />,
  },

  // ─── Near To Expiry ────────────────────────────────────────────────────────
  form_22: {
    title: "Near To Expiry All List",
    icon: <UnorderedListOutlined />,
    description: "View all items nearing their expiry date.",
    content: <NearToExpiryAllList />,
  },
  form_23: {
    title: "Near To Expiry Scan",
    icon: <ScanOutlined />,
    description: "Scan items that are near to expiry.",
    content: <NearToExpiryScan />,
  },
  form_24: {
    title: "Near To Expiry – Discount",
    icon: <PercentageOutlined />,
    description: "Apply and manage discounts for near-to-expiry items.",
    content: <NearToExpiryItem />,
  },
  form_25: {
    title: "Near To Expiry List For Approve",
    icon: <CheckCircleOutlined />,
    description: "Review and approve near to expiry item lists.",
    content: <NearToExpiryListForApprove />,
  },
  form_26: {
    title: "Near To Expiry Approved List",
    icon: <CheckSquareOutlined />,
    description: "View approved near to expiry items.",
    content: <NearToExpiryApprovedList />,
  },

  // ─── SAP Integration Reports ───────────────────────────────────────────────
  form_30: {
    title: "Store",
    icon: <ShopOutlined />,
    description: "SAP – Store integration report.",
    content: <SAPStore />,
  },
  form_31: {
    title: "Category",
    icon: <TagsOutlined />,
    description: "SAP – Category integration report.",
    content: <SAPCategory />,
  },
  form_32: {
    title: "Item Master",
    icon: <DatabaseOutlined />,
    description: "SAP – Item master integration report.",
    content: <SAPItemMaster />,
  },
  form_33: {
    title: "Purchase Order",
    icon: <ShoppingCartOutlined />,
    description: "SAP – Purchase order integration report.",
    content: <SAPPurchaseOrder />,
  },
  form_38: {
    title: "Near To Expiry",
    icon: <WarningOutlined />,
    description: "SAP – Near to expiry integration report.",
    content: <NearToExpirySAP />,
  },
  form_39: {
    title: "GRN List Report",
    icon: <FileSearchOutlined />,
    description: "SAP – GRN list integration report.",
    content: <GRNList />,
  },
  form_42: {
    title: "Stock Aging",
    icon: <HourglassOutlined />,
    description: "SAP – Stock aging integration report.",
    content: <StockAging />,
  },

  // ─── GRN Module ────────────────────────────────────────────────────────────
  form_46: {
    title: "Create GRN",
    icon: <PlusCircleOutlined />,
    description: "Raise a new Goods Receipt Note.",
    content: "Work in Progress",
  },
  form_43: {
    title: "GRN Report",
    icon: <BarChartOutlined />,
    description: "View and analyse GRN reports.",
    content: <GRNReport />,
  },
  form_48: {
    title: "GRN List",
    icon: <FileDoneOutlined />,
    description: "Browse all recorded Goods Receipt Notes.",
    content: "Work in Progress",
  },

  // ─── Admin Settings ────────────────────────────────────────────────────────
  form_9: {
    title: "Menu Group",
    icon: <FolderOutlined />,
    description: "Create and manage menu groups.",
    content: <MenuGroup />,
  },
  form_10: {
    title: "Menu Setting",
    icon: <AppstoreOutlined />,
    description: "Configure application menu structure.",
    content: <MenuSettings />,
  },
  form_11: {
    title: "Role Setting",
    icon: <SafetyCertificateOutlined />,
    description: "Create and manage custom role definitions.",
    content: <RoleSettings />,
  },
  form_13: {
    title: "Role Permission",
    icon: <KeyOutlined />,
    description: "Assign and control permissions per role.",
    content: <AssignRoleSetting />,
  },
  form_12: {
    title: "Register User",
    icon: <UserAddOutlined />,
    description: "Register new users in the system.",
    content: <RegsiterUser />,
  },
  form_14: {
    title: "Registered User List",
    icon: <TeamOutlined />,
    description: "View and manage all registered users.",
    content: <UserManagement />,
  },
  form_36: {
    title: "Approval Group",
    icon: <ClusterOutlined />,
    description: "Configure approval group definitions.",
    content: <ApprovalGroup />,
  },
  form_37: {
    title: "Approval User Mapping",
    icon: <ShareAltOutlined />,
    description: "Map users to their respective approval groups.",
    content: <ApprovalUserMapping />,
  },
  form_41: {
    title: "Update Legal Name",
    icon: <EditOutlined />,
    description: "Update the legal entity name on record.",
    content: <UpdateLegalName />,
  },
  form_49: {
    title: "Form Master",
    icon: <FormOutlined />,
    description: "Define and manage system form configurations.",
    content: <FormMaster />,
  },

  // ─── Reports ──────────────────────────────────────────────────────────────
  form_52: {
    title: "Division Wise PO GRN Summary Report",
    icon: <BarChartOutlined />,
    description: "Division-level summary of PO value, GRN value, and pending GRN.",
    content: <DivisionWisePOGRNSummaryReport />,
  },
  form_53: {
    title: "Division Vendor Fill Rate",
    icon: <AreaChartOutlined />,
    description: "Vendor fill rate analysis broken down by division.",
    content: <DivisionVendorFillRate />,
  },

  // ─── Analytics & Reports (legacy keys) ────────────────────────────────────
  "sales-analytics": {
    title: "Sales Analytics",
    icon: <LineChartOutlined />,
    description: "Analyse your sales performance and trends.",
  },
  "user-analytics": {
    title: "User Analytics",
    icon: <TeamOutlined />,
    description: "Track user behaviour and engagement metrics.",
  },
  "traffic-analytics": {
    title: "Traffic Analytics",
    icon: <AreaChartOutlined />,
    description: "Monitor website traffic and visitor patterns.",
  },
  "monthly-reports": {
    title: "Monthly Reports",
    icon: <CalendarOutlined />,
    description: "View and generate monthly performance reports.",
  },
  "quarterly-reports": {
    title: "Quarterly Reports",
    icon: <FileOutlined />,
    description: "Access quarterly business reports.",
  },
  "annual-reports": {
    title: "Annual Reports",
    icon: <TrophyOutlined />,
    description: "Review annual performance summaries.",
  },
};

export const profileMenuItems = [
  {
    key: "change-password",
    icon: <LockOutlined />,
    label: "Change Password",
  },
  { type: "divider" },
  { key: "logout", icon: <LogoutOutlined />, label: "Logout", danger: true },
];